import { createContext, Dispatch, SetStateAction, useContext, useLayoutEffect } from 'react';

type PreviewSizeContext = {
    previewSize: SupportedPreviewSizes;
    setPreviewSize: Dispatch<SetStateAction<SupportedPreviewSizes>>;
};

export type SupportedPreviewSizes = 'hidden' | 'small' | 'large';
export const PreviewSize = createContext<PreviewSizeContext>({
    previewSize: 'small',
    setPreviewSize: () => {}
});

export const usePreviewSize = (size: SupportedPreviewSizes = 'small') => {

    const { setPreviewSize } = useContext(PreviewSize);

    useLayoutEffect(() => {
        setPreviewSize(size);
    });
};